import styled from 'styled-components';

import { isSimpleValue } from '../isSimpleValue';
import { JsonLeafProps, NodeType } from '../types';
import { Row, RowProps } from './Row';

const ArrayIndex = styled.span`
  :before {
    color: ${({ theme }) => theme.colors.neutrals.grey60};
    content: attr(data-array-index);
  }
`;

const StyledJsonProperty = styled.span`
  font-family: ${({ theme }) => theme.styles.fonts.code};
`;

export const Leaf = ({
  inArray,
  indent,
  isLast,
  label,
  startDecoration,
  type,
  value,
}: JsonLeafProps & RowProps) => {
  const isSimple = isSimpleValue(type);
  return (
    <Row indent={indent} className="json-leaf" data-test="json-leaf-raw">
      {startDecoration}
      {inArray ? (
        <ArrayIndex data-array-index={`${label}: `} />
      ) : (
        <StyledJsonProperty className="json-property-key">
          {'"'}
          {label}
          {'": '}
        </StyledJsonProperty>
      )}
      <StyledJsonProperty className={`json-property-value json-property-${type}`}>
        {type === NodeType.string && '"'}
        {value}
        {type === NodeType.string && '"'}
      </StyledJsonProperty>
      {isSimple && !isLast && ','}
    </Row>
  );
};
